var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{on:{"click":_vm.generatePdf}},[_c('v-list-item-title',[_vm._v("PDF")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }